import { Container, Grid, Typography } from "@pmberjaya/cloudbank-ui";
import React from "react";
import Image from "next/image";
import Section from "../../Common/Section";
const tecnologyList = [
  {
    title: "DIRANCANG UNTUK MEMBERIKAN UP-TIME",
    description:
      "Cloudbank dibangun dengan ketersediaan tinggi sebagai tujuan utama kami. Setiap komponen platform cloudbank telah dirancang dengan mempertimbangkan redundansi. Kami memiliki redundansi di semua tingkatan termasuk beberapa Pusatdata, Sasis Komputasi, Host Komputasi, Inti jaringan, Transit IP, dan Penyimpanan SAN.",
    img: "/technology/uptimes.svg",
  },
  {
    title: "TEKNOLOGI CLOUD TERKEMUKA",
    description:
      "Kami memanfaatkan sepenuhnya platform VCloud director VMWare. Teknologi ini benar-benar membedakan kami dari virtualisasi dan penyedia cloud lainnya dengan memungkinkan kami untuk menawarkan tingkat layanan perusahaan kepada pelanggan kami dengan fitur-fitur seperti VMotion, HA, fault tolerance, dan DRS. Platform kami bersertifikat VCloud.",
    img: "/technology/cloud.svg",
  },
  {
    title: "PERANGKAT KERAS PERUSAHAAN",
    description:
      "Lingkungan kami mewakili platform perusahaan yang berskala. Setiap zona dirancang sama dan menggunakan peralatan industri terkemuka dari Fortinet, Dell Server, Mikrotik dan Cisco.",
    img: "/technology/hardware.png",
  },
  {
    title: "OTOMATISASI LAYANAN MANDIRI",
    description:
      "Kunci untuk menghadirkan cloud yang sebenarnya adalah otomatisasi dan memberikan kontrol kepada pelanggan kami. Kami tidak memiliki lusinan insinyur yang memberikan ilusi cloud otomatis. Sistem kami sebenarnya otomatis.",
    img: "/technology/automization.svg",
  },
  {
    title: "BERBAGAI MACAM SISTEM OPERASI",
    description:
      "Dari sistem operasi premium seperti Windows Server dan Redhat Enterprise Linux hingga pilihan sumber terbuka gratis seperti Centos dan Ubuntu, Anda bebas memilih apa pun yang sesuai dengan preferensi Anda.",
    img: "/technology/various.svg",
  },
];
const Technology = () => {
  return (
    <Section>
      <Typography
        variant="h2"
        className="text-heading-h2 mt-5"
        color="primary"
        alignText="center"
      >
        TEKNOLOGI KAMI
      </Typography>

      {tecnologyList.map((row, index) => (
        <Section>
          <Grid row alignItems="center">
            <Grid
              md={6}
              className={`${index % 2 === 0 ? "order-first" : "order-last"}`}
            >
              <div className="text-center">
                <Image
                  alt="technology"
                  src={row.img}
                  width={500}
                  height={400}
                />
              </div>
            </Grid>
            <Grid
              md={6}
              className={`${index % 2 === 0 ? "order-last" : "order-first"}`}
            >
              <Typography
                variant="h3"
                className="text-heading-h3"
                color="primary"
                alignText="center"
              >
                {row.title}
              </Typography>
              <Typography
                variant="h5"
                color="primary"
                className="text-paragraf mt-5"
                alignText="center"
              >
                {row.description}
              </Typography>
            </Grid>
          </Grid>
        </Section>
      ))}
    </Section>
  );
};

export default Technology;
